import LozengeController from './vd-lozenge.controller'
import template from './vd-lozenge.html'

const LozengeComponent = {
  transclude: true,
  bindings: {
    label: '@',
    disabled: '<?',
    marked: '<?',
    onDelete: '&?',
  },
  template,
  controller: LozengeController,
}

export default LozengeComponent
